import { filterVisibleItems } from '../../../../utils/common'
import {
  QA_NAME_UPLOAD_IMAGE_RELOAD,
  QA_NAME_UPLOAD_IMAGE_ROTATE,
  QA_NAME_UPLOAD_IMAGE_UNDO,
} from '../UploadImageModal.constants'

import RotateIcon from '../../../../icons/rotate-left.svg'
import UploadIcon from '../../../../icons/upload-1.svg'

// One shared list for the desktop inline buttons and the mobile "More"
// dropdown; `Icon` is desktop-only.
export function getUploadImageModalSecondaryActions({
  hasImage,
  hasRotateAction,
  hasUndoAction,
  isBusy,
  t,
  onReload,
  onRotate,
  onUndo,
}) {
  return filterVisibleItems([
    {
      Icon: null,
      disabled: isBusy,
      isVisible: hasUndoAction,
      key: 'undo',
      qaName: QA_NAME_UPLOAD_IMAGE_UNDO,
      text: t('UploadImage.UndoBtnKey'),
      onClick: onUndo,
    },
    {
      Icon: RotateIcon,
      disabled: !hasImage || isBusy,
      isVisible: hasRotateAction,
      key: 'rotate',
      qaName: QA_NAME_UPLOAD_IMAGE_ROTATE,
      text: t('UploadImage.RotateBtnKey'),
      onClick: onRotate,
    },
    {
      Icon: UploadIcon,
      disabled: isBusy,
      isVisible: true,
      key: 'reload',
      qaName: QA_NAME_UPLOAD_IMAGE_RELOAD,
      text: t('UploadImage.ReloadBtnKey'),
      onClick: onReload,
    },
  ])
}
